export const SERVER_ERROR = 1001;
export const EXPIRED_TOKEN = 1003;
export const PREVIOUS_SESSION = 1004;
export const INVALID_TOKEN = 1005;
export const SUCCESS_LOGIN = 2000;
export const CUSTOMER_CODE_INVALID = 2001;
export const USER_ID_INVALID = 2002;
export const FORCE_RESET = 2004;
export const VERIFY_OTP = 2011;
export const RESET_PASSWORD_USERID_INVALID = 2042;